import { css } from '@eti/styles';
import { Text, textVariants } from '@etg/wings';
import { rowItemSize } from '../../utils/styles';
import { jsx as _jsx } from "react/jsx-runtime";
const aisleStyles = css`
  align-items: center;
  display: flex;
  justify-content: center;
  ${rowItemSize};
`;
const Aisle = _ref => {
  let {
    row
  } = _ref;
  return /*#__PURE__*/_jsx(Text, {
    className: aisleStyles,
    "data-testid": "aisle",
    variant: textVariants._14_BOLD,
    children: row > 0 && row
  });
};
export default Aisle;
//# sourceMappingURL=Aisle.js.map